import axios from "axios";
import i18n from "../../../i18n";
import { handleHttpErrors } from "../../../modules/http";

const initialState = {};

export const feelingSickReducer = (state = initialState, action) => {
  return state;
};

const addOrUpdateFeelingSick = (formData, update) => (dispatch, getState) => {
  return axios
    .put(`/api/diet/dailyentry/sickday`, formData)
    .then(() => {
      if (update) {
        return Promise.resolve(
          i18n.t("appText.dietDiary.sickDay.update.success")
        );
      }

      return Promise.resolve(i18n.t("appText.dietDiary.sickDay.add.success"));
    })
    .catch((error) => {
      return handleHttpErrors(error.request?.status, {
        default: i18n.t("errorText.dietDiary.notFeelingWell.error"),
      });
    });
};

const removeFeelingSick = (formData) => (dispatch, getState) => {
  return axios
    .put(`/api/diet/dailyentry/sickday`, formData)
    .then(() => {
      return Promise.resolve(
        i18n.t("appText.dietDiary.sickDay.remove.success")
      );
    })
    .catch((error) => {
      return handleHttpErrors(error.request?.status, {
        default: i18n.t("errorText.dietDiary.notFeelingWell.error"),
      });
    });
};

export const mapDispatchToProps = {
  addOrUpdateFeelingSick,
  removeFeelingSick,
};
